import { BaseModel } from "@/models/BaseModel";
import languages from "@/locales/supported-locals.js";

export class InfoCategory extends BaseModel {
  constructor({ id = null, name, company, info_type, ...rest }) {
    super();

    this.id = id;
    this.name = name;
    this.company = company;
    this.info_type = info_type;

    // Generate all language fields dynamically
    Object.keys(languages).forEach((code) => {
      const normalized = code.replace("-", "_"); // zh-hans -> zh_hans
      const key = `name_${normalized}`;
      this[key] = rest[key] || ""; // initiera från rest-data eller tom sträng
    });
  }

  get isCreatedBySystem() {
    return !this.company;
  }
}

export default InfoCategory;
